export default __webpack_public_path__ + "static/media/gu.63700bdd.svg";